import { useQuery } from '@tanstack/react-query';
import { fetchDashboardInit } from '../api/dashboard.api';

/**
 * React Query hook for fetching and managing core dashboard state.
 * Caches data and handles background refetching logic.
 */
export const useDashboardInit = () => {
  return useQuery({
    queryKey: ['dashboard', 'init'],
    queryFn: fetchDashboardInit,
    staleTime: 30000, // 30 seconds
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
